export default __webpack_public_path__ + "static/media/vip10.ae038eb3.gif";